import request from 'sb-request'
import { getGqlQuery } from 'common/helpers'
import { reducers, getState } from 'redux/core'


const fetch = async () => {
  const { routing: { location: { pathname } } } = getState()

  reducers.view.referralLandingPage.setFetching(true)

  await fetchProducts()

  const [ channelCode, personalCode ] = (
    pathname.split('/')
      .filter((p) => p !== 'referral')
      .filter((p) => p.length)
  )

  if (personalCode && channelCode) {
    await fetchReferral({ personalCode, channelCode })
  }

  reducers.view.referralLandingPage.setFetching(false)
}

const fetchReferral = ({ personalCode, channelCode }) => (
  request.post('rest/referral/visit', {
    withErrorModal: false,
    body: {
      personalCode,
      channelCode,
    },
  })
    .then((data) => reducers.view.referralLandingPage.setReferrerData(data))
)

const fetchProducts = () => (
  request.post('graphql?name=fetchMixPageProducts', {
    body: {
      query: `{
        ${getGqlQuery('products', { includeProducts: [ 951, 929, 1078 ].map((value) => String(value)) })} {
          id
          img
          name
          brand
          retailPrice: retailPriceForcedVisibility
          upchargePrice
        }
      }`,
    },
  })
    .then(({ products }) => reducers.view.referralLandingPage.setProducts(products))
)

export default {
  fetch,
}
